<template>
  <div class="nav">
    <div class="nav_left" @click="toDashboard">
      <img :src="logoIcon" alt="" />
    </div>
    <div class="nav_right">
      <autocomplete v-if="isShowAutocomplete" />
      <!-- <el-dropdown
        trigger="click"
        @visible-change="handleVisibleChange"
        @command="toggleLanguage"
      >
        <el-button class="button-language flex-center" type="info">
          <div class="box">
            <img :src="globeIcon" alt="" />{{ texts.navbar.language
            }}<img :src="languageFlag ? upIcon : downIcon" alt="" />
          </div>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>{{
            texts.navbar.language === "简体中文" ? "English" : "简体中文"
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <el-button class="button-login" type="primary" @click="toLogin()">{{
        texts.navbar.login
      }}</el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import autocomplete from "@/components/autocomplete"
import { initWebInfo } from "@/utils/autoweb"

export default {
  name: "NavHeader",
  components: { autocomplete },
  data() {
    return {
      logoIcon: require("@/assets/images/logo.webp"),
      searchIcon: require("@/assets/icons/search.svg"),
      globeIcon: require("@/assets/icons/globe.svg"),
      upIcon: require("@/assets/icons/up.svg"),
      downIcon: require("@/assets/icons/down.svg"),
      selected: "zh", // 默认语言
      searchkey: "",
      blogKey: Math.random().toString(),
      languageFlag: false,
    }
  },
  computed: {
    ...mapState([
      "texts",
      "currentBlogId",
      "selectedLanguage",
      "currentEnglishBlogId",
    ]),
    isShowAutocomplete() {
      return this.$route.name !== "Dashboard"
    },
  },
  methods: {
    ...mapMutations(["SET_TEXTS"]),
    toLogin() {
      window.open("https://union.funlinkads.com/#/login")
    },
    handleVisibleChange() {
      this.languageFlag = !this.languageFlag
    },
    toggleLanguage() {
      const isChinese = this.selected === "zh"
      const currentLanguage = isChinese ? "en" : "zh"
      initWebInfo(currentLanguage) // 重新获取侧边栏
      this.SET_TEXTS(currentLanguage) // 更新语言文本
      this.selected = currentLanguage
      // 路由跳转 - 触发文章详情获取接口
      const blogid = isChinese ? this.currentEnglishBlogId : this.currentBlogId
      // console.log(isChinese, blogid, "blogid")
      this.$router.replace({
        path: this.$route.path,
        // query: { ...this.$route.query, _t: Date.now() },
        query: { blogid, _t: Date.now() },
      })

      // store.dispatch('setWebInfo', res.data)
      // // this.selected = value; // 更新选中的语言
      // let blogids = value === 'chinese' ? 6 : 7
      // this.$router.push({
      //   query: {
      //     blogid: blogids,
      //   },
      // });
    },
    toDashboard() {
      if (this.$route.path === "/") return
      this.$router.push({
        path: "/",
      })
    },
  },
  created() {
    this.selected =
      this.selectedLanguage || localStorage.getItem("selectedLanguage") || "zh"
  },
}
</script>
<style lang="scss" scoped>
.nav {
  background: #fff;
  z-index: 999;
  height: 72px;
  border-bottom: 1px solid #efefef;
  // box-shadow: 0 6px 12px hsl(0deg 0% 80% / 40%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0px;
  position: fixed;
  width: 100%;
  top: 0;
  .nav_left {
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      margin-left: 24px;
      width: 140px;
      height: 40px;
      object-fit: contain;
    }
  }
  .nav_right {
    margin-right: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;
    ::v-deep(.input-with-select) {
      .el-input__inner {
        width: 280px;
        height: 36px;
        border: none;
        border-radius: 8px;
        background-color: #f6f6f7;
        padding-left: 40px;
      }
      // .el-input__prefix {
      //   width: 16px;
      //   left: 12px;
      //   top: 10px;
      // }
    }
    .button-language {
      width: 123px;
      height: 38px;
      color: #0057ff;
      border: none;
      &:hover {
        background-color: #f6f6f7;
      }
      &:focus {
        background-color: #f6f6f7;
      }
      .box {
        display: flex;
        align-items: center;
        gap: 6px;
      }
    }
    .button-login {
      width: 80px;
      height: 38px;
      margin: 0;
      border: none;
      background-color: #0057ff;
      color: #ffffff;
    }
  }
}
</style>

<style lang="scss">
.el-popper {
  width: 121px;
  border-radius: 8px !important;
  // text-align: center;
  color: #010007cc;
  padding: 0 !important;
  .popper__arrow {
    display: none !important;
  }
  .el-dropdown-menu__item {
    // height: 46px;
    // line-height: 46px;
    border-radius: 8px !important;
    &:hover {
      color: #010007cc !important;
      background-color: #0057ff1a !important;
    }
  }
}
</style>
